import React from "react"
import {
  cardHighlight,
  flexBox,
  getMediaFor,
  maxLines,
  MEDIA_BREAKPOINT_KEYS,
  responsiveFontSize,
} from "style/style_snippets"
import Grid from "@mui/material/Grid"
import { Typography } from "@mui/material"
const cardWrapperStyle = {
  cardContainer: {
    cursor: "pointer",
    borderRadius: 0,
    ...cardHighlight,
    ...getMediaFor("height", "250px", {
      [MEDIA_BREAKPOINT_KEYS.sm]: "250px",
      [MEDIA_BREAKPOINT_KEYS.md]: "300px",
    }),
    display: "grid",
    gridTemplateRows: "16% 1fr",
    gridTemplateColumns: "1fr",
    gridGap: "5%",
  },

  headContainer: {
    height: "100%",
    padding: "10px 0 0 10px",

    tag: {
      width: "fit-content",
      fontWeight: 600,
      fontSize: responsiveFontSize(14, 16),
      height: "100%",
      backgroundColor: "black",
      color: "white",
      ...flexBox.row,
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: "25px",
      paddingRight: "25px",
      textTransform: "capitalize",
    },
  },

  content: {
    ...getMediaFor("padding", "0 30px 20px 20px", {
      [MEDIA_BREAKPOINT_KEYS.sm]: "0 30px 25px 25px",
      [MEDIA_BREAKPOINT_KEYS.md]: "0 30px 40px 40px",
    }),
    display: "grid",
    gridTemplateRows: "min-content max-content 1fr",
    gridTemplateColumns: "1fr",
    gridGap: "8%",
  },

  title: {
    textTransform: "capitalize",
    ...maxLines(2),
  },

  description: {
    ...maxLines(3),
  },

  children: {
    alignSelf: "center",
  },
}

const CardWrapper = props => {
  const { tag, title, description, onClick, children, grid, cursor } = props

  return (
    <Grid {...grid} item onClick={() => onClick()}>
      <div css={{...cardWrapperStyle.cardContainer, cursor: cursor ?? "pointer"}}>
        <div css={cardWrapperStyle.headContainer}>
          <span css={cardWrapperStyle.headContainer.tag}>{tag}</span>
        </div>

        <div css={cardWrapperStyle.content}>
          <Typography css={cardWrapperStyle.title} variant={"h3"}>
            {title}
          </Typography>

          {description && (
            <Typography css={cardWrapperStyle.description} variant={"body1"}>
              {description}
            </Typography>
          )}
          {children && <div css={cardWrapperStyle.children}>{children}</div>}
        </div>
      </div>
    </Grid>
  )
}

export default CardWrapper
